// Core modules
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Application services and model
import { CampaignService } from '@core/services/campaign.service';
import { ForgotPasswordComponent } from '@shared/components/forgot-password/forgot-password.component';
import { LoginComponent } from '@shared/components/login/login.component';
import { SignUpComponent } from '@shared/components/sign-up/sign-up.component';
import { CampaignModel } from '@shared/models/campaign.model';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { RequestService } from '@app/core/services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

/**
 * Product list component
 */
@Component({
  selector: 'app-campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrls: ['./campaign-list.component.scss'],
})
export class CampaignListComponent implements OnInit {

  public baseUrl: string = 'https://cashbackswebapicore.whitedune-47840e2f.westeurope.azurecontainerapps.io';
  public visibleCampaigns: number = 8;

  public campaigns: CampaignModel[];

  deferredPrompt: any;
  showButton = false;
  email: any;
  lang: string = 'nl-NL';
  subscribeForm: FormGroup = this.formBuilder.group({
    email: [this.route.snapshot.queryParams.e, [Validators.required, Validators.email]]
  });;

  /**
   * Life cycle method
   * @param campaignService CampaignService
   */
  constructor(
    private campaignService: CampaignService,
    private requestService: RequestService,
    public dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    ) {
    }

  /**
   * Life cycle init method and get all product list data
   */
  ngOnInit() {
    this.lang = this.route.snapshot.queryParams.lang??'nl-NL'
    this.campaignService.getCampaigns(this.lang).subscribe((data: CampaignModel[]) => {
      this.campaigns = data.filter(c=>new Date(c.startDate) < new Date());
    });
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
  }

  /**
   * Show more campaigns
   */
  showMore() {
    this.visibleCampaigns = this.visibleCampaigns + 4;
  }

  addToHomeScreen() {
    // hide our user interface that shows our A2HS button
    this.showButton = false;
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          // console.log('User accepted the A2HS prompt');
        } else {
          // console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      });
  }

  /**
   * Open login dialog
   */
  openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '568px',
      backdropClass: 'kbk-backdrop',
      data: { email: this.email},
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.email = data.email;
      if (data.event === 'signUp') {
        this.openSignUpDialog();
      } else if (data.event === 'forgotPassword') {
        this.openForgotPasswordDialog();
      }
    });
  }

  /**
   * Open sign up dialog
   */
  openSignUpDialog(): void {
    const dialogRef = this.dialog.open(SignUpComponent, {
      width: '568px',
      backdropClass: 'kbk-backdrop',
      data: { email: this.email, lang: this.lang  },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data === 'login') {
        this.openLoginDialog();
      }
    });
  }

  /**
   * Open forgot dialog component
   */
  openForgotPasswordDialog(): void {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '568px',
      backdropClass: 'kbk-backdrop',
      data: { email: this.email, lang: this.lang},
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data === 'signUp') {
        this.openSignUpDialog();
      }
    });
  }

  openCampaign(campaign: CampaignModel)
  {
    if (campaign.external)
    {
      window.open(campaign.urlPath, "_blank"); 
    }
    else {
      this.router.navigate(["campaigns",campaign.urlPath, campaign.campaignId]);
    }
  }

  subscribe()
  {
    if (this.subscribeForm.valid) {
      //console.log('Form Submitted!', this.subscribeForm.value.email, this.lang);
    }
    this.requestService.saveSubscriber(this.subscribeForm.value.email, this.lang).subscribe((result)=>{
      //implement this
      this.snackBar.open(this.translate.instant('NEWSLETTER_SUBSCRIPTION'), 'X', { duration: 3000 });
    },(error)=>{
      this.snackBar.open(this.translate.instant('ERROR_OCCURRED'), 'X', { duration: 3000 })
    });
  }
}
